export default __webpack_public_path__ + "static/media/Lumera2.bad04084.png";